import React from 'react'
import * as defineType from './defineTypeTypes'
import useLookupService from '../../../../services/lookup/useLookupService'
import { useForm } from 'react-final-form'
import useTranslate from '../../../../i18n/useTranslate'
import useCheckPermission from '../../../../utilities/checkPermission'
import useAuthenStore from '../../../../stores/authen/authenStore'
import useWebService from '../../../../services/web/useWebService'
import useLoading from '../../../../control/loading/useLoading'
import useAppFolderAndTabStore from '../../../../stores/appFolderAndTab/appFolderAndTabStore'
import useFolderAndTab from '../../project/useFolderAndTab'
import { validateModeAccordionError } from '../../../../utilities/validate'
import { generatePath, useHistory, useLocation } from 'react-router-dom'
import { encryptionAES } from '../../../../utilities/encryption'
import { RoutePath } from '../../../../router/routesConfig'
import useHistoryAction from '../../../../stores/history/useHistoryAction'
import useHistoryStore from '../../../../stores/history/useHistoryStore'

const useDefineType = (props: defineType.UseDefineTypeType) => {
    const { onChang, projectData, disabled } = props
    const translate = useTranslate()
    const callLookup = useLookupService()
    const [expanded, setExpanded] = React.useState<string | false>('panel1')
    const [projectType, setProjectType] = React.useState<defineType.OptType[]>([])
    const form = useForm()
    const { checkDisabledProjectType } = useCheckPermission()
    const disabledDefineType = checkDisabledProjectType(projectData)
    const authenStore = useAuthenStore()
    const webServiceHook = useWebService()
    const loadingHook = useLoading()
    const history = useHistory()
    const { state } = useLocation()

    const appFolderAndTabStore = useAppFolderAndTabStore()
    const tabAndFolderHook = useFolderAndTab()
    const historyStoreAction = useHistoryAction()
    const historyStore = useHistoryStore()

    React.useEffect(() => {
        getProjectType()
    }, [translate.languageStore.currentLanguage])

    const getProjectType = async () => {
        const res = await callLookup.callProjectTypeLut()
        const formatedData = res.result.map((itm) => {
            return {
                label: translate.languageStore.currentLanguage === translate.languageKey.th ? itm.name_th : itm.name_en,
                value: `${itm.id}`,
            }
        })
        setProjectType(formatedData)
    }

    const handleChange = (panel: string) => (event: React.ChangeEvent<{}>, newExpanded: boolean) => {
        setExpanded(newExpanded ? panel : false)
    }

    const handleChangProjectType = (val: defineType.OptType) => {
        if (onChang) {
            onChang(val)
        }
    }
    const handleChangeIsNotAboutPeople = () => {
        /* Resets the values back to the initial values the form was initialized with. Or empties all the values if the form was not initialized. If you provide initialValues they will be used as the new initial values.
             Note that if you are calling reset() and not specify new initial values, you must call it with no arguments. Be careful to avoid things like promise.catch(reset) or onChange={form.reset} in React, as they will get arguments passed to them and reinitialize your form. */
        form.reset()
    }

    const handleSubmitOfficerEdit = (fieldNames: string[]) => {
        const isError = validateModeAccordionError(fieldNames, form.getState())
        return new Promise((resolve, reject) => {
            const param = createParamOfficerUpdate()
            if (!isError) {
                loadingHook.loadingOpen()
                processUpdate(param)
                    .then(() => {
                        resolve('')
                    })
                    .catch(() => {
                        reject('')
                    })
                    .finally(() => {
                        historyStoreAction.updateDisplayHistory(projectData.submittedID)
                        loadingHook.loadingClose()
                    })
            } else {
                reject('')
            }
        })
    }

    const processUpdate = async (param: any) => {
        const isNotAboutPeople = form.getState().values.isNotAboutPeople ?? false
        let response
        if (isNotAboutPeople) {
            response = await webServiceHook.specifyProjectType(param).then(() => {
                loadTabAndFolder()
            })
        } else {
            response = await webServiceHook.updateProjectConsiderType(param).then(() => {
                tabAndFolderHook.reloadProjectData(projectData.projectID, projectData.submittedID)
            })
        }
        return response
    }

    const createParamOfficerUpdate = () => {
        const formVals = form.getState().values
        const isNotAboutPeople = formVals.isNotAboutPeople ?? false
        let param = {}
        if (isNotAboutPeople) {
            param = {
                loginUserID: authenStore.profile.userId,
                projectID: projectData.projectID,
                submittedID: projectData.submittedID,
                isNotAboutPeople: formVals.isNotAboutPeople,
                considerTypeID: null,
                reviewerRemark: formVals.commentWithFormat?.content ?? null,
                reviewerRemarkHTML: formVals.commentWithFormat?.contentHtml ?? null,
                committeeInfo: [],
                reviewerUserID: null,
                isDraft: false,
            }
        } else {
            param = {
                submittedID: projectData.submittedID,
                considerTypeID: formVals.projectType?.value ? Number(formVals.projectType?.value) : null,
                reviewerRemark: formVals.commentWithFormat?.content ?? null,
                reviewerRemarkHTML: formVals.commentWithFormat?.contentHtml ?? null,
            }
        }
        return param
    }

    const loadTabAndFolder = async (isReloadProjectData: boolean = true, ignoreCustomFolder: boolean = false) => {
        tabAndFolderHook.loadTabAndFolder(projectData, appFolderAndTabStore, isReloadProjectData, ignoreCustomFolder)
    }

    const navigateToLogs = (event: any) => {
        event.stopPropagation()
        const paramData = {
            projectID: projectData?.projectID,
            submittedID: projectData?.submittedID,
            submittedTypeID: projectData?.submitTypeInfo?.value,
        }
        const encryptedProjectData = encryptionAES(JSON.stringify(paramData))

        const path = generatePath(RoutePath.considerTypeHistory, {
            projectData: encryptedProjectData,
        })
        history.push({
            pathname: path,
            state: state,
        })
    }

    return {
        projectType,
        expanded,
        displayHistory: historyStore.displayConsiderTypeHistory,
        onChangeAccordion: handleChange,
        onChangProjectType: handleChangProjectType,
        onChangeIsNotAboutPeople: handleChangeIsNotAboutPeople,
        useAccordionMode: !disabledDefineType && disabled && !projectData.isNotAboutPeople,
        handleSubmitOfficerEdit,
        navigateToLogs,
    }
}

export default useDefineType
